const initialize = () => {
    // Slide down/up to reveal or hide target element from clicked element
    $('a.revealer').click(function(event){
        event.preventDefault();
        let targetSelector = $(this).attr('href');
        if ($(targetSelector).is(":visible")) {
            $(targetSelector).slideUp();
        } else {
            $(targetSelector).slideDown();
        }
    });
};

export default {
    initialize,
};